<template>
  <div class="cargo_list">
    <div class="list_top_content">
      <h3 class="posr">
        {{ cargoList.ClassName }}
        <span
          class="posa"
          v-if="type == 2"
          :class="{ haveCancel: cargoList.CancelString == '取消成功' }"
        >
          {{ cargoList.CancelString }}
        </span>
        <span class="posa" v-if="type == 1 && cargoList.OrderStatusText">
          {{ cargoList.OrderStatusText }}
        </span>
      </h3>
      <div class="info-area">
        <div class="row info-text">
          <div class="col-12">
            <div class="row">
              <div class="col-auto">
                <img :src="require(`@/assets/images/icon/home_small.svg`)" />
                <h4>主辦單位</h4>
              </div>
              <div class="col-auto">
                <p>{{ cargoList.CompanyName }}</p>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-auto">
                <img :src="require(`@/assets/images/icon/map_small.svg`)" />
                <h4>上課地點</h4>
              </div>
              <div class="col-auto">
                <p>{{ cargoList.ClassAddress }}</p>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-auto">
                <img :src="require(`@/assets/images/icon/nuber_small.svg`)" />
                <h4>發票號碼</h4>
              </div>
              <div class="col-auto">
                <p>{{ cargoList.InvoiceNo }}</p>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-auto">
                <img :src="require(`@/assets/images/icon/time_small.svg`)" />
                <h4>開課日期</h4>
              </div>
              <div class="col-auto">
                <p>{{ cargoList.ClassBTime }}</p>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-auto">
                <img :src="require(`@/assets/images/icon/man_small.svg`)" />
                <h4>報名人數</h4>
              </div>
              <div class="col-auto">
                <p>{{ cargoList.OrderCnt }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="discount-area">
          <div class="bonus one-row">
            <p>紅利點數</p>
            <p>-{{ cargoList.Payoff }}</p>
          </div>
          <div class="enjoy one-row">
            <p>即享券</p>
            <p>-{{ cargoList.DiscAmnt30 }}</p>
          </div>
          <div class="discount one-row">
            <p>折價券</p>
            <p>-{{ cargoList.DiscAmnt10 }}</p>
          </div>
          <div class="the-line"></div>
          <div class="pay one-row">
            <p>實付金額</p>
            <p>${{ cargoList.Amount }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="refundAccount" v-if="type == 2 && refundAccount">
      <div class="row">
        <div class="col-auto">
          <h4>退款帳戶</h4>
        </div>
        <div class="col-auto">
          <p>{{ refundAccount }}</p>
        </div>
      </div>
    </div>
    <cargo-list-bottom-content :order-detail="cargoList" v-if="type == 1" />
  </div>
</template>

<script>
import CargoListBottomContent from '@/components/cargo/CargoListBottomContent';

export default {
  props: {
    cargoList: {
      type: Object,
      required: true
    },
    type: {
      type: [String, Number],
      default() {
        return 1; // 1 == 訂單查詢、 2 == 取消訂單
      }
    }
  },
  data() {
    return {
      refAState: false
    };
  },
  computed: {
    refundAccount() {
      if (this.cargoList.RefundBank || this.cargoList.RefundAccount) {
        return `${this.cargoList.RefundBank} ${this.cargoList.RefundAccount}`;
      }

      return null;
    }
  },
  components: {
    CargoListBottomContent
  },
  methods: {
    checkCancel(val) {
      if (val === undefined) {
        return 'del';
      }
      if (val == '已刷退') {
        this.refAState = true;
        return 'haveCancel';
      }
    }
  }
};
</script>
